import React from 'react'
import { addRedirectQueryToRoute } from '@chegg-wt/core/utils/routes'
import { Dispatch } from 'redux'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { connect } from 'react-redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { useRoutesContext } from '../RoutesContext'

import AppLink from '../AppLink'
import * as Styled from './styled'

interface CitationsUpsellWrapperProps {
  onUserClickCreateAccountCTA: () => void
  onUserClickSignInCTA: () => void
  children: React.ReactNode
}

const CitationsUpsellWrapper: React.FC<CitationsUpsellWrapperProps> = ({
  onUserClickCreateAccountCTA,
  onUserClickSignInCTA,
  children,
}) => {
  const { toSignup, toLogin } = useRoutesContext()
  const currentLocation = window.location.href
  const upgradeSignUpRoute = addRedirectQueryToRoute(toSignup(), currentLocation)
  const upgradeSignInRoute = addRedirectQueryToRoute(toLogin(), currentLocation)

  return (
    <Styled.Container>
      <Styled.CenterContent>
        <Styled.TextBox>
          <AppLink route={upgradeSignUpRoute}>
            <Styled.AuthLink onClick={onUserClickCreateAccountCTA}>
              Create account
            </Styled.AuthLink>
          </AppLink>
          &nbsp;or&nbsp;
          <AppLink route={upgradeSignInRoute}>
            <Styled.AuthLink onClick={onUserClickSignInCTA}>sign in</Styled.AuthLink>
          </AppLink>
          &nbsp;to start a new citation list
        </Styled.TextBox>
      </Styled.CenterContent>
      <Styled.Children aria-hidden="true">{children}</Styled.Children>
    </Styled.Container>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClickCreateAccountCTA: () =>
    dispatch(userClick({ origin: origins.citationsDashCreateAccountCitationWidgetCTA })),
  onUserClickSignInCTA: () =>
    dispatch(userClick({ origin: origins.citationsDashSignInCitationWidgetCTA })),
})

export default connect(null, mapDispatchToProps)(CitationsUpsellWrapper)
